import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';
import '../../css/Anamnese.css';
import '../../css/style.css';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Quais os seus objetivos com o programa de treinamento?", tipo: "checkbox", temOutros: true },
    { id: 1, texto: "2. Qual o seu condicionamento físico atual?", tipo: "radio" },
    { id: 2, texto: "3. Você treina a quanto tempo?", tipo: "text", placeholder: "Ex: 6 meses" },
    { id: 3, texto: "4. Qual a sua disponibilidade para treinar?", tipo: "text", placeholder: "Ex: 3x na semana" },
    { id: 4, texto: "5. Quais dias você tem disponibilidade?", tipo: "checkbox" },
    { id: 5, texto: "6. Quais exercícios você pratica atualmente?", tipo: "checkbox", temOutros: true },
    { id: 6, texto: "7. Qual era a intensidade dos exercícios?", tipo: "radio" },
    { id: 7, texto: "8. Refeições realizadas normalmente:", tipo: "checkbox" },
    { id: 8, texto: "9. Realiza algum tipo de dieta?", tipo: "radio" },
    { id: 9, texto: "10. Utiliza algum suplemento alimentar?", tipo: "text" },
    { id: 10, texto: "11. Já realizou algum teste de esforço?", tipo: "radio" },
    { id: 11, texto: "12. Você consome bebidas alcoólicas?", tipo: "radio" },
    { id: 12, texto: "13. Ingere líquidos com frequência?", tipo: "radio" },
    { id: 13, texto: "14. Você tem diabetes?", tipo: "radio" },
    { id: 14, texto: "15. Qual seu nível de glicemia em jejum?", tipo: "radio" },
    { id: 15, texto: "16. Qual seu nível de colesterol?", tipo: "radio" },
    { id: 16, texto: "17. Você fuma?", tipo: "radio" },
    { id: 17, texto: "18. Doenças ou queixas:", tipo: "checkbox", temOutros: true },
    { id: 18, texto: "19. Medicamentos:", tipo: "checkbox", temOutros: true },
    { id: 19, texto: "20. Lesões articulares/musculares?", tipo: "checkbox" },
    { id: 20, texto: "21. Histórico familiar:", tipo: "checkbox" }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: ["Emagrecimento", "Condicionamento Físico", "Estética", "Lazer", "Hipertrofia Muscular", "Saúde e prevenção"] },
    { id: 1, opcoes: ["Inativo", "Irregularmente ativo", "Ativo", "Muito ativo ou atleta"] },
    { id: 2, opcoes: [] },
    { id: 3, opcoes: [] },
    { id: 4, opcoes: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"] },
    { id: 5, opcoes: ["Musculação", "Natação", "Dança", "Corrida", "Pilates", "Futebol", "Hidroginástica", "Caminhada"] },
    { id: 6, opcoes: ["Baixa", "Moderada", "Alta"] },
    { id: 7, opcoes: ["Café da manhã", "Colação", "Almoço", "Lanche da tarde", "Jantar", "Ceia"] },
    { id: 8, opcoes: ["Não", "A menos de 3 meses", "De 3 a 6 meses", "De 6 meses a 1 ano", "A mais de 1 ano"] },
    { id: 9, opcoes: [] },
    { id: 10, opcoes: ["Não", "A menos de 1 ano", "A mais de 1 ano"] },
    { id: 11, opcoes: ["Não", "1 vez por mês", "De 2 a 4 vezes por mês", "De 2 a 3 vezes por semana", "4 vezes ou mais por semana"] },
    { id: 12, opcoes: ["Não", "Menos de 1L por dia", "De 1L a 2L por dia", "Mais de 2L por dia"] },
    { id: 13, opcoes: ["Não", "Não, mas há casos na família", "Sim, mas estou em tratamento", "Sim, mas não está controlada"] },
    { id: 14, opcoes: ["Não conhece", "Inferior a 70mg/dL", "Entre 70 e 90mg/dL", "Entre 100 e 125mg/dL", "Superior a 126mg/dL"] },
    { id: 15, opcoes: ["Não conhece", "Inferior a 200mg/dL", "De 200 a 239mg/dL", "Superior a 239mg/dL"] },
    { id: 16, opcoes: ["Não", "Abandonou a menos de 5 anos", "Abandonou a menos de 10 anos", "Fuma menos de 10 cigarros por dia", "Fuma de 10 a 30 cigarros por dia", "Fuma mais de 30 cigarros por dia", "Fuma charuto ou cachimbo"] },
    { id: 17, opcoes: ["Nenhuma", "Anemia", "Epilepsia", "Varizes", "Asma", "Hipertensão", "Diabetes", "Hepatite", "Dores musculares"] },
    { id: 18, opcoes: ["Nenhum", "Atidepressivo", "Antihipertensivo", "Betabloqueador", "Broncodilatador", "Contraceptivo", "Calmante", "Insulina"] },
    { id: 19, opcoes: ["Nenhuma", "Ruptura muscular", "Ruptura ligamentar", "Tendinite", "Fratura", "Entorse", "Cirurgia", "Hérnia de disco", "Não possui"] },
    { id: 20, opcoes: ["Nenhuma", "Anemia", "Epilepsia", "Varizes", "Asma", "Hipertensão", "Diabetes", "Hepatite", "Hipotensão", "Hipercolesterolemia", "Dores musculares", "Cardiopatia"] }
];

function AnamneseAdulto({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 3;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    const [respostasSelecionadas, setRespostasSelecionadas] = useState(evaluationData?.anamnesis ||
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );

    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    useEffect(() => {
        if (evaluationData?.anamnesis) {
            setRespostasSelecionadas(evaluationData.anamnesis);
        }
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseAdultos");

    // Estado local para o select do modal
    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (pergunta) => {
        // Busca o valor atual dentro do objeto do estado
        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");

        // Busca as opções corretas baseadas no ID da pergunta
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                <div className="answer-container">

                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            onChange={e => atualizarResposta(pergunta.id, e.target.value, 'text')}
                        />
                    )}

                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}

                    {pergunta.temOutros && (
                        <label className="answer-item">
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={Array.isArray(r) ? r.some(v => v.startsWith("Outros:")) : r.startsWith("Outros:")}
                                onChange={() => atualizarResposta(pergunta.id, "Outros: ", pergunta.tipo)}
                            />
                            <p className="answer-title">Outros:</p>
                            {(Array.isArray(r) ? r.some(v => v.startsWith("Outros:")) : r.startsWith("Outros:")) && (
                                <input
                                    className="answer-text entrada-outros-anamnese"
                                    type="text"
                                    placeholder="Especifique..."
                                    value={Array.isArray(r)
                                        ? r.find(v => v.startsWith("Outros:"))?.replace("Outros: ", "") || ""
                                        : r.replace("Outros: ", "")}
                                    onChange={(e) => {
                                        const texto = "Outros: " + e.target.value;
                                        if (pergunta.tipo === 'checkbox') {
                                            const filtrado = r.filter(v => !v.startsWith("Outros:"));
                                            atualizarResposta(pergunta.id, [...filtrado, texto], 'radio');
                                        } else {
                                            atualizarResposta(pergunta.id, texto, 'radio');
                                        }
                                    }}
                                />
                            )}
                        </label>
                    )}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // A etapa seguinte depende do perfil do aluno (no idoso, Classificação Funcional).
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const toAntropometria = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            if (response.data.evaluationId && setEvaluationId) {
                if (!evaluationId) {
                    if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
                    aluno.avaliacoesRealizadas.push({
                        id: response.data.evaluationId,
                        data: new Date().toISOString()
                    });
                }
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                <div className="questions-container">
                    <div className="questions-left">
                        {perguntasEsquerda.map(renderPergunta)}
                    </div>
                    <div className="questions-right">
                        {perguntasDireita.map(renderPergunta)}
                    </div>
                </div>

                {etapa === 3 && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toAntropometria}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 3 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseAdulto;